<template>
<div class="mx2 flex justify-center">
    <div>
        <div class="flex nav-btn-wrapper md-mt3 mt2">
        <big-nav-btn 
            v-for="link in navlist" :key="link.id"
            :linktext="link.linktext"
            :link="link.link"
            :img="link.img"
        />
        </div>
        <section class="mx-auto max-width-4 mt3 mb4 col-12" v-if="isTime && messages.length !== 0">
            <h2 class="bold h3 mb1">Neueste Nachrichten vom Messageboard</h2>
            <h3 class="h4 regular mb3 color-gray">Verfolge die Konversation in Echt-Zeit auf unseren Screens - oder mach selbst mit!</h3>
            <div class="relative">
                <div class="veil"></div>
                <div class="flex mb2 board-comment" v-for="message in messages.slice(0, 3)" :key="message.id">
                    <div class="user-bubble p2 semibold white mr2 justify-start" style="height: fit-content;">{{message.name}}</div>
                    <div class="bg-color-lightpink text-bubble col-12 p2">
                        <!-- <div class="msg-deco"></div> -->
                        <p class="p2 h3 semibold">{{message.message}}</p>
                        <p class="comment-time pr2 pt2 text-right">{{message.created_at}}</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="mx-auto max-width-4 mt3 col-12">
            <h2 class="bold h3 mb1">Featured Fotoalben</h2>
            <h3 class="h4 regular mb3 color-gray">Lasse die besten Momente der letzten Abende noch einmal revue passieren und hinterlasse Kommentare! </h3>
            <div class="md-flex col-12 mb4">
                <router-link v-if="galleries.length > 0" :to="'/gallery/' + galleries[0].id + '/0'" class="front-page-pic md-col-4 col-12" v-lazyload>
                    <div class="overlay flex flex-column justify-center">
                        <p class="p2 center white h2">{{galleries[0].name}}</p>
                    </div>
                    <div class="skeleton skeleton-loading"></div>
                    <img class=" cover" :data-url="galleries[0].thumbnaillink"/>
                </router-link>
                <router-link v-if="galleries.length > 0" :to="'/gallery/' + galleries[1].id + '/0'" class="front-page-pic md-col-4 col-12" v-lazyload>
                    <div class="overlay flex flex-column justify-center">
                        <p class="p2 center white h2">{{galleries[1].name}}</p>
                    </div>
                    <div class="skeleton skeleton-loading"></div>
                    <img class=" cover" :data-url="galleries[1].thumbnaillink"/>
                </router-link>
                <router-link v-if="galleries.length > 0" :to="'/gallery/' + galleries[2].id + '/0'" class="front-page-pic md-col-4 col-12" v-lazyload>
                    <div class="overlay flex flex-column justify-center">
                        <p class="p2 center white h2">{{galleries[2].name}}</p>
                    </div>
                    <div class="skeleton skeleton-loading"></div>
                    <img class="cover" style="height: 100%;" :data-url="galleries[2].thumbnaillink"/>
                </router-link>
            </div>
        </section>
    </div>

</div>
</template>
<script>
import BigNavBtn from './BigNavBtn.vue';
import axios from 'axios';
export default {
  name: "Home",
  data() {
    return {
        isTime: false,
        navlist: [
            {
                id: 1,
                linktext: 'Message-Board',
                link: '/shoutout',
                img: 'megaphone-1.svg'
            },
            // {
            //     id: 2,
            //     linktext: 'Musikwunsch',
            //     link: '/music-wishlist',
            //     img: 'music-note.svg'
            // },
            {
                id: 3,
                linktext: 'Fotoalben',
                link: '/gallery-overview',
                img: 'gallery.svg'
            }
        ],  
        session: {},
        msg_text: '',
        phone_nr: '',
        user_name: '',

        not_filled_msg_text: false,
        not_filled_phone_nr: false,
        not_filled_user_name: false,

        messages: [],
        galleries: {
        }
    };
  },
  components: {
    'big-nav-btn': BigNavBtn,
  },
  computed: {
    formattedTime(){
        let arr = this.messages[0].created_at.split(" ", 2);
        let newDate = arr[1]
        let nextDate = newDate.slice(0, 5);
        return nextDate;
    },
  },
  created(){
      this.calculateTime();
  },
  mounted(){
    axios.get('https://bilder.nachtschicht-schortens.de/app/api-messages/json')
        .then(response => {
            console.log(response)
            this.messages = response.data.data

            for(let y = 0; y < this.messages.length; y++){
                let arr =  Array()
                arr = this.messages[y].created_at.split(" ", 2);
                let newDate = arr[1]
                let nextDate = newDate.slice(0, 5);
                this.messages[y].created_at = nextDate

            }
        })
        .catch(function() {
            console.log('error')
        })

      let that = this;
        let url =  'https://bilder.nachtschicht-schortens.de/public-api/get/galleries/json';
        axios.post(url)
        .then(response => {
          that.galleries = response.data.data.reverse() 
          
        })
        .catch(function (error) {
          console.log(error);
        });
  },
  methods: {
    calculateTime(){
      // timer for updating
      let self = this;
      let seconds = 0;

      //Initial Timecheck
      var objDate = new Date();
      var hours = objDate.getHours();
      var day = objDate.getDay();
      if(hours < 6 || hours > 17 && day == 5 || day == 6){
          self.isTime = true;
      }else{
          self.isTime = false;
      }

      function getTime() {
          seconds++; 
          if (seconds === 60) {
            var objDate = new Date();
            var hours = objDate.getHours();
            var day = objDate.getDay();
            if(hours < 6 || hours > 17 && day == 5 || day == 6){
                self.isTime = true;
            }else{
                self.isTime = false;
            }
            seconds = 0; //reset timer   
          }
        }
        setInterval(getTime, 1000); 
    },
  }
}
</script>
<style>
.nav-btn-wrapper{
    gap: 2rem;
}
.big-nav-btn{
    margin: 0;
}
@media(max-width: 1100px){
    .big-nav-btn{
        margin: 0 auto;
    }
}

</style>